<template>
  <div class="page-wrapper">
    <div class="device-list">
      <div class="list-title">设备列表</div>
      <ul class="device-ul">
        <li
          v-for="(device, index) in deviceList"
          :key="index"
          @click="handleDeviceClick(device)"
        >
          {{ device.deviceName }}
        </li>
      </ul>
    </div>

    <div class="map-container" ref="mapContainer"></div>
  </div>
</template>

<script>
/* global BMap */
import { request } from '@/utils/request'
import redcarImg from '@/assets/redcar.png'
import greencarImg from '@/assets/greencar.png'

export default {
  name: 'deviceMonitor',
  data() {
    return {
      map: null,
      deviceList: [],
      currentLabel: null,
      currentMarker: null
    }
  },
  mounted() {
    this.initMap()
    this.loadAllDeviceLocations()
  },
  methods: {
    initMap() {
      this.map = new BMap.Map(this.$refs.mapContainer)
      const defaultPoint = new BMap.Point(87.6168, 44.1706)
      this.map.centerAndZoom(defaultPoint, 15)
      this.map.enableScrollWheelZoom(true)

      // 地图点击关闭标签（判断是否点在 label 上）
      this.map.addEventListener('click', (e) => {
        if (this.currentLabel && this.currentLabel.V && this.currentLabel.V.contains(e.domEvent.target)) {
          return
        }

        if (this.currentLabel) {
          this.map.removeOverlay(this.currentLabel)
          this.currentLabel = null
          this.currentMarker = null
        }
      })
    },

    loadAllDeviceLocations() {
      request({
        url: '/device/remote_location',
        method: 'get'
      })
        .then((res) => {
          const dataArray = res.data.data
          if (!Array.isArray(dataArray)) return

          this.deviceList = dataArray
          this.map.clearOverlays()
          this.currentLabel = null

          dataArray.forEach((device, index) => {
            const {
              lastLat, lastLon, deviceName, imei,
              groupName, status, lastLocationInfoType,
              lastLocationTime, lastDataTime, lastSpeed,
              lastCourse, lastIsRepairData, lastMileage, heartBeatAcc
            } = device

            if (!lastLat || !lastLon) return

            const point = new BMap.Point(lastLon, lastLat)

            const isRed = status === 4
            const carImg = isRed ? redcarImg : greencarImg
            const carIcon = new BMap.Icon(carImg, new BMap.Size(50, 50), {
              anchor: new BMap.Size(25, 25),
              imageSize: new BMap.Size(50, 50)
            })

            const carMarker = new BMap.Marker(point, { icon: carIcon })
            carMarker.setRotation(Number(lastCourse) || 0)
            this.map.addOverlay(carMarker)

            carMarker.addEventListener('click', (e) => {
              if (this.currentLabel) {
                this.map.removeOverlay(this.currentLabel)
              }

              const labelHtml = `
                <div style="font-size: 12px; max-width: 300px; line-height: 1.6;">
                  <strong>设备名称:</strong> ${deviceName}<br/>
                  <strong>设备号:</strong> ${imei}<br/>
                  <strong>分组名称:</strong> ${groupName}<br/>
                  <strong>状态:</strong> ${this.getStatusText(status)}<br/>
                  <strong>定位类型:</strong> ${this.getLocationTypeText(lastLocationInfoType)}<br/>
                  <strong>最后定位时间:</strong> ${lastLocationTime}<br/>
                  <strong>数据更新时间:</strong> ${lastDataTime}<br/>
                  <strong>速度:</strong> ${lastSpeed} km/h<br/>
                  <strong>方向:</strong> ${lastCourse}°<br/>
                  <strong>是否补传:</strong> ${lastIsRepairData == 1 ? '是' : '否'}<br/>
                  <strong>里程:</strong> ${lastMileage} km<br/>
                  <strong>心跳ACC:</strong> ${heartBeatAcc == 1 ? '开' : '关'}
                </div>
              `

              const label = new BMap.Label(labelHtml, {
                position: point,
                offset: new BMap.Size(25, -60)
              })

              label.setStyle({
                background: '#fff',
                border: '1px solid #555',
                padding: '8px',
                borderRadius: '4px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                maxWidth: '300px'
              })

              this.map.addOverlay(label)
              this.currentLabel = label
              this.currentMarker = carMarker

              e.domEvent.stopPropagation()
            })

            if (index === 0) {
              this.map.panTo(point)
            }
          })
        })
        .catch(err => {
          console.error('加载设备失败', err)
        })
    },

    handleDeviceClick(device) {
      const { lastLat, lastLon } = device
      if (!lastLat || !lastLon) return
      const point = new BMap.Point(lastLon, lastLat)
      this.map.panTo(point)
    },

    getStatusText(code) {
      const map = {
        2: '离线',
        4: '运动',
        5: '静止',
        6: '过期',
        7: 'SIM卡过期',
        9: '未激活'
      }
      return map[code] || '未知'
    },

    getLocationTypeText(code) {
      const map = {
        1: '卫星',
        2: 'LBS',
        3: 'WIFI',
        4: '蓝牙'
      }
      return map[code] || '未知'
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  display: flex;
  width: 100%;
  height: 100vh;
}

.device-list {
  width: 20%;
  background-color: #f4f4f4;
  border-right: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: auto;
}

.list-title {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 16px;
}

.device-ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.device-ul li {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
}

.device-ul li:hover {
  background-color: #e6f7ff;
}

.map-container {
  width: 80%;
  height: 100%;
}
</style>
